// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import getColor from "@insite/mobius/utilities/getColor";
import { productImageCarouselStyles } from "@synd/Overrides/Components/ProductImageCarousel";
import { color, xScreen } from "@synd/XDL/Utilities";
import { css } from "styled-components";

export const getImageCss = (borderColor: string) => css`
    width: 100%;
    height: 100%;
    max-width: 68px;
    max-height: 68px;
    cursor: pointer;
    justify-content: flex-start;
    border: 1px solid ${getColor(borderColor)};
    border-radius: 8px;

    img {
        max-width: 68px;
        max-height: 68px;
    }
`;


productImageCarouselStyles.image = {
    css: getImageCss("transparent"),
};

productImageCarouselStyles.selectedImage = {
    css: getImageCss("common.ui5"),
};

productImageCarouselStyles.dotButton = {
    css: css`
        height: 10px;
        width: 10px;
        padding: 0;
        margin: 0 4px;
        border: 1px solid ${color("common.ui11")};
        background: ${color("common.white")};
        &:hover,
        &:active {
            background: ${color("common.ui10")};
            border: none;
        }
        &:focus {
            outline: none;
        }
        &:active {
            background: ${color("common.ui11")};
            border: none;
        }
    `,
};
productImageCarouselStyles.carouselSlideInner = {

};

productImageCarouselStyles.wrapper = {
    css: css`
        max-height: 430px;
        max-width: 100%;
        ${xScreen("lte", "md")} {
            max-height: unset;
        }
        .swiper-slide {
            width: 68px;
            height: 68px;
        }

        @media print {
            display: none;
        }
    `,
}